<div class="bc-text-chat-control-panel" [@slideInFromBottomAnimation]>
  <svg-icon icon="x" (click)="toggleButtonClick()" class="icon-close" id="toggle-text-chat-more-actions"></svg-icon>

  <div class="container-fluid">
    <div class="control-panel-groups">
      <div *ngIf="hasSendGroupPanelItem()" class="control-panel-group control-panel-group-send">
        <a *ngIf="hasWrapUps" (click)="wrapUpButtonClick()" class="btn btn-light" id="text-chat-wrap-up-button">
          <span>{{ 'textChatWorkWidget.wrapUp' | translate }} </span>
        </a>
      </div>
      <div [ngClass]="hasSendGroupPanelItem() ? 'control-panel-group control-panel-group-action' : 'single-control-panel-group'">
        <a (click)="transferButtonClick()" class="btn btn-light" id="text-chat-transfer-button">
          <span> {{ 'textChatWorkWidget.transfer' | translate }} </span>
        </a>
        <a (click)="endTextChatClick()" class="btn btn-light" id="text-chat-end-button">
          <span>{{ 'textChatWorkWidget.endChat' | translate }}</span>
        </a>
      </div>
    </div>
  </div>
</div>
